import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-2 w-full"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "background-green rounded-full flex justify-center items-center" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "pi pi-check text-white p-1 font-bold",
    style: {"font-size":"0.5rem"}
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "color-green font-bold" }, /*#__PURE__*/_toDisplayString(`SESUAI`), -1)
const _hoisted_9 = {
  key: 1,
  class: "flex items-center gap-2 w-full"
}
const _hoisted_10 = { class: "background-red rounded-full flex justify-center items-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "color-red font-bold" }, /*#__PURE__*/_toDisplayString(`Tidak Sesuai`), -1)
const _hoisted_12 = { class: "" }
const _hoisted_13 = {
  key: 1,
  class: "font-bold color-blue-grey"
}
const _hoisted_14 = { class: "" }
const _hoisted_15 = {
  key: 0,
  class: "color-blue-grey font-bold"
}
const _hoisted_16 = {
  key: 1,
  class: "color-blue-grey font-bold"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey py-1 px-4" }, /*#__PURE__*/_toDisplayString(`Bayar`), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxExport = _resolveComponent("DxExport")
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")
  const _component_DxColumn = _resolveComponent("DxColumn")
  const _component_Icon = _resolveComponent("Icon")
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")
  const _component_DxGrouping = _resolveComponent("DxGrouping")
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_DxDataGrid, {
      id: "delivery-item-table-id",
      class: "delivery-item-table",
      "column-auto-width": true,
      "allow-column-reordering": false,
      "show-column-lines": false,
      "show-row-lines": true,
      "show-borders": true,
      "row-alternation-enabled": true,
      "allow-column-resizing": false,
      "word-wrap-enabled": true,
      "data-source": $setup.data,
      "key-expr": "Id",
      "no-data-text": $setup.noDataText
    }, {
      nameCourierTemplate: _withCtx(({ data }) => [
        _createVNode("div", _hoisted_1, [
          _createVNode("p", _hoisted_2, _toDisplayString(`${data.data?.Kurir}`), 1)
        ])
      ]),
      totalComissionTemplate: _withCtx(({ data }) => [
        _createVNode("div", _hoisted_3, [
          _createVNode("p", _hoisted_4, _toDisplayString(`Rp. ${new Number(data.data.Total).toLocaleString("id-ID")}`), 1)
        ])
      ]),
      confirmedTemplate: _withCtx(({ data }) => [
        _createVNode("div", _hoisted_5, [
          (data.data.IsConfirmed)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_Icon, {
                    icon: $setup.icons.exclamationIcon,
                    class: "text-white",
                    style: {"font-size":"1rem"}
                  }, null, 8, ["icon"])
                ]),
                _hoisted_11
              ]))
        ])
      ]),
      statusPembayaranTemplate: _withCtx(({ data }) => [
        _createVNode("div", _hoisted_12, [
          (data.data.PaymentStatus)
            ? (_openBlock(), _createBlock("section", {
                key: 0,
                class: "flex",
                innerHTML: _ctx.$statusPayment(data.data.PaymentStatus)
              }, null, 8, ["innerHTML"]))
            : (_openBlock(), _createBlock("p", _hoisted_13, "-"))
        ])
      ]),
      tanggalTerbayarTemplate: _withCtx(({ data }) => [
        _createVNode("div", _hoisted_14, [
          (data.data?.UpdatedAt)
            ? (_openBlock(), _createBlock("p", _hoisted_15, _toDisplayString($setup.moment(data.data?.UpdatedAt).format('DD-MM-YY HH:mm')), 1))
            : (_openBlock(), _createBlock("p", _hoisted_16, "-"))
        ])
      ]),
      actionTemplate: _withCtx(({ data }) => [
        _createVNode("div", null, [
          (_ctx.$route.name === 'comission-manual-payment')
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "bg-white inline-block cursor-pointer rounded-md",
                style: {"box-shadow":"0px 2px 12px rgba(0, 0, 0, 0.12)"},
                onClick: ($event: any) => ($setup.payComission(data.data))
              }, [
                _hoisted_17
              ], 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxExport, {
          enabled: true,
          "allow-export-selected-data": false
        }),
        _createVNode(_component_DxFilterRow, { visible: $setup.showFilterRow }, null, 8, ["visible"]),
        _createVNode(_component_DxHeaderFilter, { visible: $setup.showHeaderFilter }, null, 8, ["visible"]),
        _createVNode(_component_DxColumnChooser, {
          enabled: false,
          mode: "select",
          title: "Pilih Kolom",
          "allow-search": false
        }),
        _createVNode(_component_DxColumn, {
          "group-index": 0,
          "data-field": "Agen",
          caption: "Agen",
          "allow-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Kurir",
          caption: "Nama Kurir",
          "min-width": 200,
          "cell-template": "nameCourierTemplate",
          visible: true,
          alignment: "left",
          "allow-grouping": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Total",
          caption: "Total Komisi",
          "min-width": 150,
          alignment: "left",
          "cell-template": "totalComissionTemplate",
          "allow-grouping": false
        }),
        _createVNode(_component_DxColumn, {
          alignment: "left",
          "data-field": "IsConfirmed",
          caption: "Konfirmasi Agen",
          "min-width": 150,
          "cell-template": "confirmedTemplate",
          "allow-filtering": false,
          "allow-sorting": false,
          "allow-grouping": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "StatusPayment",
          caption: "Status Pembayaran",
          visible: true,
          "min-width": 150,
          "cell-template": "statusPembayaranTemplate",
          "allow-search": false,
          "allow-grouping": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "UpdateAt",
          caption: "Tanggal Terbayar",
          alignment: "left",
          visible: true,
          "min-width": 150,
          "cell-template": "tanggalTerbayarTemplate",
          "data-type": "datetime",
          format: "dd-MM-yyyy, HH:mm",
          "allow-grouping": false
        }),
        _createVNode(_component_DxColumn, {
          caption: "",
          "min-width": 150,
          visible: true,
          "cell-template": "actionTemplate",
          "allow-filtering": false,
          "allow-sorting": false,
          "allow-grouping": false
        }),
        _createVNode(_component_DxGroupPanel, {
          visible: true,
          "empty-panel-text": "Drag kolom ke sini untuk mengelompokkan menurut kolom tersebut"
        }),
        _createVNode(_component_DxGrouping, {
          "auto-expand-all": $setup.autoExpandAll,
          "context-menu-enabled": true,
          "expand-mode": "rowClick"
        }, null, 8, ["auto-expand-all"])
      ]),
      _: 1
    }, 8, ["data-source", "no-data-text"]),
    _createVNode(_component_DxLoadPanel, {
      "close-on-outside-click": false,
      visible: $setup.loading,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ($setup.loading = $event)),
      position: $setup.position,
      shading: true,
      "shading-color": "rgba(0,0,0,0.4)"
    }, null, 8, ["visible", "position"])
  ]))
}